import { useState } from "react"

export default function Board() {
    const [squares, setSquares] = useState(Array(9).fill(null));

    function handleClick(i) {
        const nextSquares = squares.slice()
        switch (squares[i]) {

            case null:
                nextSquares[i] = "X";
                break;
            case "X":
                nextSquares[i] = "O";
                break;
            case "O":
                nextSquares[i] = null;
                break;
        }


        setSquares(nextSquares);
        let winner = checkWin(nextSquares)

        if (winner != null){
            printWinner(winner)
        }
    }

    function printWinner(winner){
        console.log(`Winner: ${winner}`)
    }
    function clearBoard(){
        const nextSquares = Array(9).fill(null);
        setSquares(nextSquares);
    }
    return (
        <>
            <div className="board-row">
                <Square val={squares[0]} handleClick={() => handleClick(0)} />
                <Square val={squares[1]} handleClick={() => handleClick(1)} />
                <Square val={squares[2]} handleClick={() => handleClick(2)} />
            </div>
            <div className="board-row">
                <Square val={squares[3]} handleClick={() => handleClick(3)} />
                <Square val={squares[4]} handleClick={() => handleClick(4)} />
                <Square val={squares[5]} handleClick={() => handleClick(5)} />
            </div>
            <div className="board-row">
                <Square val={squares[6]} handleClick={() => handleClick(6)} />
                <Square val={squares[7]} handleClick={() => handleClick(7)} />
                <Square val={squares[8]} handleClick={() => handleClick(8)} />
            </div>
            <div className="reset-button">
                <br />
                <br />
                <Reset handleClick={clearBoard}/>
            </div>
        </>
    )
}


function Square({ val, handleClick }) {
    //   const [value, setValue] = useState(null);

    //   function handleClick() {
    //     console.log('Clicked')
    //   }

    return (
        <button
            className="square"
            onClick={handleClick}
        >
            {val}
        </button>
    );
}


function Reset({handleClick}){

    return (
        <button
        className="reset"
        onClick={handleClick}
        >
            Reset
        </button>
    )
}


function checkWin(board){


    /*
    0,1,2
    3,4,5
    6,7,8

    Check [0,1,2], [3,4,5], [6,7,8], [0,3,6], [1,4,7], [2,5,8], [0,4,8], [2,4,6]

    */


    for(let row = 0; row <= 6; row += 3){



        if(board[row] != null && (board[row] == board[row+1]) && (board[row] == board[row+2])){
            return board[row]
        }


    }

    for(let col = 0; col <= 2; col ++){

        if(board[col] != null && (board[col] == board[col+3]) && (board[col] == board[col+6])){
            return board[col]
        }

    }

    if(board[0] != null && (board[0] == board[4]) && (board[0] == board[8])){
        return board[0]
    }
    if(board[2] != null && (board[2] == board[4]) && (board[2] == board[6])){

        return board[2]
        
    }

    return null;




}